export default __webpack_public_path__ + "static/media/logo.e516dfa0.png";